const CART_PREFIX = '@@cart/';

export const CART_ACTION_TYPES = {
    ADD_ITEM: `${CART_PREFIX}ADD_ITEM`,
    REMOVE_ITEM: `${CART_PREFIX}REMOVE_ITEM`,
    UPDATE_QUANTITY: `${CART_PREFIX}UPDATE_QUANTITY`,
    UPDATE_ITEM: `${CART_PREFIX}UPDATE_ITEM`,
    CLEAR_CART: `${CART_PREFIX}CLEAR_CART`,
}